import { Component } from "@angular/core";
import { MatSidenavContainer, MatSidenavContent } from "@angular/material/sidenav";
import { AnonymousToolbarComponent } from "../anonymous-toolbar/anonymous-toolbar.component";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "anonymous-layout",
    templateUrl: "./anonymous-layout.component.html",
    styleUrl: "./anonymous-layout.component.scss",
    imports: [MatSidenavContainer, MatSidenavContent, AnonymousToolbarComponent, RouterOutlet],
})
export class AnonymousLayoutComponent {
    // Intentionally minimal - layout defined in template only
    // In future might have use to add functionality here for an unauthenticated user
}
